<template>
  <div class="register_bg">
    <RollDownBar caption="Фильтр" @changeShow="changeStyle">
      <template slot="headers">
        <v-row style="padding: 0">
          <v-col md="5" style="padding: 0 10px; height: 50px">
            <v-text-field v-model="winner_inn" label="ИНН" hide-details clearable style="padding: 0" />
          </v-col>
          <v-col md="5" style="padding: 0 10px; height: 50px">
            <v-text-field v-model="notificationNumber" label="Номер протокола" hide-details clearable
              style="padding: 0" />
          </v-col>
          <v-col md="2" style="
              padding: 5px 20px;
              height: 50px;
              display: flex;
              justify-content: flex-end;
            ">
            <v-btn @click="headersFilter = !headersFilter" class="ml-2">
              <v-icon>tune</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template slot="default">
        <v-row>
          <v-col md="1">
            <v-row>
              <v-col xs="12">
                <div class="xls">
                  <img :src="XLSICON" class="onHover" style="width: 35px" alt="Иконка Excell" title="Получить файл"
                    @click="saveAllToFile" v-if="!loadingFile" />
                  <Loader class="accents" v-else style="width: 35px" :width="45" />
                  <span>Скачать</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="3">
            <v-radio-group v-model="radioDateSelected">
              <v-radio v-for="(item, index) in dateRadio" :key="index" :label="item.text" :value="item.text"></v-radio>
            </v-radio-group>
            <DateWithMenu :placeholder="radioDateSelected" :items="daysItems" v-model="date" :init="dateInit" />
          </v-col>
          <v-col md="3">
            <h4>Сумма ГО:</h4>
            <PriceInput style="position: relative; top: 10px; width: 200px" v-model="go_range[0]" placeholder="От" />

            <v-divider class="mx-2" inset vertical></v-divider>
            <PriceInput style="position: relative; top: 10px; width: 200px" v-model="go_range[1]" placeholder="До" />
          </v-col>
          <v-col :md="checkRole(roleObj.usersService) ? '3' : '4'">
            <v-checkbox v-model="needGO" label="Только если требуется ГО" />
            <v-checkbox v-model="showIgnore" label="Показать тех кто игнорируется" />
          </v-col>
          <v-col md="1">
            <v-row>
              <v-col xs="6"><v-btn @click="toDefault" class="ml-2">
                  <span>Сбросить</span>
                </v-btn></v-col>
              <v-col xs="6">
                <v-btn @click="find" class="ml-2" :loading="loading">
                  <span>Найти</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="1" v-if="checkRole(roleObj.usersService)">
            <div class="xls">
              <img :src="XLSICON" class="onHover" style="width: 35px" alt="Иконка Excell" title="Получить файл"
                @click="saveAllToFileFromRobot" v-if="!robotxlsLoading" />
              <Loader class="accents" v-else style="width: 35px" :width="45" />
              <span>Робот</span>
            </div>
          </v-col>
        </v-row>
      </template>
    </RollDownBar>
    <v-card :style="cardStyle">
      <v-data-table :class="`register_bg_table ${showFilter ? 'show_filter' : ''}`" dense :headers="filtredHeaders"
        :items="protocolsRegisterBG" :options.sync="options" :server-items-length="totalDesserts" :footer-props="{
          'items-per-page-options': options.itemsPerPageOptions,
        }" :loading="loading" loading-text="Считываем данные ..." :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :items-per-page.sync="updateItemsPerPage" fixed-header>
        <template v-slot:item="{ item }">
          <tr :style="`background-color: ${item.color}; height: 59px;`" v-if="getIgnore(item)">
            <td v-if="headers[0].show">
              {{ addCommas(item.guaranteeing) }}
              <v-tooltip bottom v-if="item.not_required === 1">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="
                      border: 1px solid black;
                      border-radius: 50%;
                      width: 20px;
                      height: 20px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-size: 36px;
                      line-height: 15px;
                    ">-</span>
                </template>
                <span> Не требуется по ч.8.1 ст.96 44-ФЗ </span>
              </v-tooltip>
            </td>
            <td v-if="headers[1].show">
              {{ item.contractTerm ? item.contractTerm : noDate }}
            </td>
            <td v-if="headers[2].show">
              {{
                item.deliveryDate
                ? moment(item.deliveryDate).format("DD.MM.YYYY")
                : noDate
              }}
            </td>
            <td v-if="headers[3].show" name="aboutCompany">
              <v-row>
                <v-col md="11"><v-tooltip bottom v-if="item.winner_inn">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{
                        item.winner_inn
                      }}</span>
                    </template>
                    <span> ИНН </span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="item.winner_name">
                    <template v-slot:activator="{ on, attrs }">
                      <p style="
                          text-transform: capitalize;
                          padding: 0;
                          margin: 0;
                        " v-bind="attrs" v-on="on">
                        {{ item.winner_name.shortName }}
                        <!-- {{
                      regOOO.test(item.winner_name)
                        ? item.winner_name.replace(regOOO, "OOO")
                        : item.winner_name.replace("-.", "")
                    }} -->
                      </p>
                    </template>
                    <span>
                      Полное наименование:
                      {{ item.winner_name.fullName }}
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.egrul">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" style="
                          text-transform: capitalize;
                          padding: 0;
                          margin: 0;
                        ">
                        {{ item.egrul && item.egrul }}
                      </p>
                    </template>
                    <span> Адрес регистрации компании или ИП </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.director && !reqDateIP.test(item.director)">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" style="
                          text-transform: capitalize;
                          padding: 0;
                          margin: 0;
                        ">
                        {{ item.director && item.director }}
                      </p>
                    </template>
                    <span v-if="!reqDateIP.test(item.director)">
                      Директор
                    </span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="item.registerDate">
                    <template v-slot:activator="{ on, attrs }">
                      <p v-bind="attrs" v-on="on" style="
                          text-transform: capitalize;
                          padding: 0;
                          margin: 0;
                        ">
                        {{
                          item.registerDate &&
                          moment(item.registerDate).format("DD.MM.YYYY")
                        }}
                      </p>
                    </template>
                    <span> Дата регистрации </span>
                  </v-tooltip></v-col>
                <v-col md="1"><v-tooltip bottom v-if="item.winner_inn">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <svg style="width: 20px; height: 20px" viewBox="0 0 24 24" @click="() => setIgnoreWinner(item)">
                          <path :fill="findIgnore(item) ? 'red' : 'currentColor'"
                            d="M22.11 21.46L2.39 1.73L1.11 3L7 8.89V10.39C6.66 10.08 6.24 9.85 5.78 9.73L5 9.5C4.18 9.29 3.31 9.61 2.82 10.35C2.44 10.92 2.42 11.66 2.67 12.3L5.23 18.73C6.5 21.91 9.57 24 13 24C15.5 24 17.7 22.85 19.17 21.06L20.84 22.73L22.11 21.46M13 22C10.39 22 8.05 20.41 7.09 18L4.5 11.45L5 11.59C5.5 11.71 5.85 12.05 6 12.5L7 15H9V10.89L17.75 19.64C16.66 21.07 14.94 22 13 22M9 5.8L7.09 3.89C7.36 2.8 8.33 2 9.5 2C9.69 2 9.87 2 10.04 2.06C10.25 .89 11.27 0 12.5 0C13.56 0 14.46 .66 14.83 1.59C15.04 1.53 15.27 1.5 15.5 1.5C16.88 1.5 18 2.62 18 4V4.55C18.16 4.5 18.33 4.5 18.5 4.5C19.88 4.5 21 5.62 21 7V16C21 16.56 20.94 17.11 20.83 17.63L19 15.8V7C19 6.72 18.78 6.5 18.5 6.5S18 6.72 18 7V12H16V4C16 3.72 15.78 3.5 15.5 3.5S15 3.72 15 4V11.8L13 9.8V2.5C13 2.22 12.78 2 12.5 2S12 2.22 12 2.5V8.8L10 6.8V4.5C10 4.22 9.78 4 9.5 4S9 4.22 9 4.5V5.8Z" />
                        </svg>
                      </span>
                    </template>
                    <span>
                      <span v-if="findIgnore(item)">Убрать из Ингорируемых</span>
                      <span v-else>Добавить в Игнорируемые</span>
                    </span>
                  </v-tooltip></v-col>
              </v-row>
            </td>
            <td v-if="headers[4].show" name="finance">
              <v-tooltip bottom v-if="item.balansYear">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" style="text-transform: capitalize; padding: 0; margin: 0">
                    {{ item.balansYear && item.balansYear }}
                  </p>
                </template>
                <span> Год </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.revenue">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" style="text-transform: capitalize; padding: 0; margin: 0">
                    {{ item.revenue && addCommas(item.revenue) }}
                  </p>
                </template>
                <span> Выручка </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.profit">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" style="text-transform: capitalize; padding: 0; margin: 0">
                    {{ item.profit && addCommas(item.profit) }}
                  </p>
                </template>
                <span> Прибыль </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.balans">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" style="text-transform: capitalize; padding: 0; margin: 0">
                    {{ item.balans && addCommas(item.balans) }}
                  </p>
                </template>
                <span>
                  <span>Баланс</span>
                </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.ocveds">
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" style="text-transform: capitalize; padding: 0; margin: 0">
                    {{ item.ocveds && item.ocveds }}
                  </p>
                </template>
                <span>
                  <span>ОКВЕД</span>
                </span>
              </v-tooltip>
            </td>
            <td v-if="headers[5].show" name="order">
              <a :href="getEIS(item.notificationNumber)" target="_blank">{{
                item.notificationNumber
              }}</a>
              <v-tooltip bottom v-if="item.isSmp">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="ml-2" style="color: red">
                    СМП
                  </span>
                </template>
                <span>
                  НМЦК: {{ addCommas(item.nmck) }}<br />
                  Предложение: {{ addCommas(item.lowPrice) }}<br />
                  Процент снижения:{{ item.procent }}
                </span>
              </v-tooltip>
            </td>
            <td v-if="headers[6].show" name="aboutOrder">
              <p>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{
                      textLimit(item.title)
                    }}</span>
                  </template>
                  <span>{{ item.title }}</span>
                </v-tooltip>
              </p>
              <p>
                <span v-if="item.customer">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{
                        textLimit(item.customer, 50)
                      }}</span>
                    </template>
                    <span>
                      {{ item.customer }} ({{
                        item.customer_inn ? item.customer_inn : noData
                      }})
                      <br />
                      Регион:
                      {{ item.customer_region ? item.customer_region : noData }}
                    </span>
                  </v-tooltip>
                </span>
                <span v-else>{{ noData }}</span>
              </p>
            </td>
            <td v-if="headers[7].show">
              <div style="display: grid; justify-content: center; row-gap: 10px">
                <div style="display: flex; justify-content: center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small :loading="false" icon @click="toCalc(item)">
                        <v-icon v-on="on" style="font-size: 20px">fa fa-calculator</v-icon>
                      </v-btn>
                    </template>
                    <span>Переход в калькулятор</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn small icon @click="() => colorize(item)" style="font-size: 20px">
                        <v-icon v-on="on" style="font-size: 20px">fa fa-palette</v-icon>
                      </v-btn>
                    </template>
                    <span>Выбрать Цвет</span>
                  </v-tooltip>
                </div>
                <div style="display: flex; justify-content: center">
                  <v-tooltip bottom v-if="!item.firm_info.phones.length ||
                    !item.firm_info.emails.length
                    ">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on" @click="updateContact(item.winner_inn)">
                        mdi-database-arrow-left
                      </v-icon>
                    </template>
                    <span>Получить контакты по компании</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="primary" dark v-bind="attrs" v-on="on" @click="updateContact(item.winner_inn)">
                        update
                      </v-icon>
                    </template>
                    <span>Обновить контакты по компании или получить весь список
                      если больше чем 3</span>
                  </v-tooltip>
                </div>

                <div style="display: flex; justify-content: center">
                  <v-menu rounded offset-y v-if="item.firm_info.phones.length">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon v-bind="attrs" v-on="on">phone</v-icon>
                    </template>

                    <v-list style="max-height: 200px">
                      <v-list-item v-for="(row, index) in item.firm_info.phones" :key="index" link>
                        <span @click="copyToClipboard(row.phone)">
                          <v-list-item-title v-text="row.phone">
                            {{ row.phone }}
                          </v-list-item-title>
                        </span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu rounded offset-y v-if="item.firm_info.emails.length">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon v-bind="attrs" v-on="on">email</v-icon>
                    </template>

                    <v-list style="max-height: 200px">
                      <v-list-item v-for="(row, index) in item.firm_info.emails" :key="index" link>
                        <span @click="copyToClipboard(row.email)">
                          <v-list-item-title v-text="row.email">
                            {{ row.email }}
                          </v-list-item-title>
                        </span>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="changeColor" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Изменить цвет </v-card-title>
        <v-card-text>
          <v-color-picker dot-size="10" hide-inputs mode="rgba" v-model="rowColor" />
          <div v-if="showSwatches">
            <h3 style="margin-bottom: 10px">Избранные цвета</h3>
            <div class="colors_block">
              <span v-for="color in swatches" :style="`background-color: ${color}`" :key="color"
                @click="() => (rowColor = color)"></span>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="removeColor">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="changeColor = false">
            Отменить
          </v-btn>
          <v-btn color="green darken-1" text @click="setColorRow"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="headersFilter" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Какие заголовки видны </v-card-title>
        <v-card-text>
          <v-checkbox style="margin: 0" v-for="(header, index) in headers" v-model="header.show" :label="header.text"
            :key="index" row />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="chancelHeadersChange">
            По умолчанию
          </v-btn>
          <v-btn color="green darken-1" text @click="saveHeaders"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import moment from "moment";
import XLSICON from "@/assets/xls.svg";
import { textLimit } from "@/plugins/textLimit";
import { copyToClipboard } from "@/plugins/copyToClipboard";
import Loader from "@/components/loading.vue";
import DateWithMenu from "@/components/DateWithMenu.vue";
import PriceInput from "@/components/priceInput.vue";
import RollDownBar from "@/components/RollDownBar.vue";
import { DeepCopy } from "../../service/DeepCopy";
import { roleObj } from '@/plugins/roles.js';

const headers = [
  {
    text: "Размер ГО",
    align: "left",
    filterable: false,
    sortable: true,
    value: "guaranteeing",
    width: "160px",
    show: true,
  },
  {
    text: "Срок контракта",
    align: "center",
    filterable: false,
    sortable: true,
    value: "contractTerm.date",
    show: true,
  },
  {
    text: "Срок обязательств",
    align: "center",
    filterable: false,
    sortable: true,
    value: "purchase.deliveryDate",
    show: true,
  },
  {
    text: "О компании",
    align: "center",
    filterable: false,
    sortable: false,
    value: "aboutCompany",
    show: true,
    width: "20%",
  },
  {
    text: "Финансы",
    align: "center",
    filterable: false,
    sortable: false,
    value: "finance",
    show: true,
    width: "20%",
  },
  {
    text: "Закупка",
    align: "center",
    filterable: false,
    sortable: false,
    value: "order",
    show: true,
  },
  {
    text: "О Закупке",
    align: "center",
    filterable: false,
    sortable: false,
    value: "aboutOrder",
    show: true,
    width: "10%",
  },
  {
    text: "Действия",
    align: "center",
    filterable: false,
    sortable: false,
    value: "contacts",
    width: "100px",
    show: true,
  },
];

export default {
  name: "register_bg",
  components: {
    Loader,
    DateWithMenu,
    PriceInput,
    RollDownBar,
  },
  data: () => ({
    roleObj,
    XLSICON,
    moment,
    textLimit,
    copyToClipboard,
    reqDateIP: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$|^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$/,
    regOOO: /ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ/gi,
    loading: false,
    loadingFile: false,
    headersFilter: false,
    changeColor: false,
    rowColor: "grba(255,255,255,1)",
    selectRow: null,
    date: ["", ""],
    dateInit: true,
    contractDate: ["", ""],
    law: [44],
    winner_inn: "",
    notificationNumber: "",
    noData: "Нет данных",
    noDate: "Отсутствует",
    dateRadio: [
      { text: "По сроку контракта" },
      { text: "По сроку обязательств" },
    ],
    radioDateSelected: "По сроку контракта",
    go_range: [10, 1000000000000],
    options: {
      page: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 25, 50, 100, -1],
    },
    needGO: false,
    lawItems: [
      { name: "44-ФЗ", value: 44 },
      { name: "223-Ф3", value: 223 },
      { name: "615-ПП", value: 615 },
      { name: "Коммерция", value: 1 },
    ],
    daysItems: [
      { name: "месяц", value: 30 },
      { name: "2 недели", value: 14 },
      { name: "1 неделя", value: 7 },
      { name: "3 дня", value: 3 },
      { name: "1 день", value: 1 },
    ],
    headers: DeepCopy(headers),
    menuContract: false,
    menu: false,
    sortBy: ["guaranteeing"],
    sortDesc: [true],
    updateItemsPerPage: null,
    cardStyle: "height: calc(100vh - 345px); overflow: hidden",
    showFilter: true,
    showIgnore: false,
    ignoreList: [],
    robotxlsLoading: false
  }),
  methods: {
    findIgnore(item) {
      return this.ignoreList.find((row) =>
        row.inn === item.winner_inn ? true : false
      );
    },
    getIgnore(item) {
      const find = this.findIgnore(item);
      if (!find) {
        return true;
      }

      return find && this.showIgnore ? true : false;
    },
    async getIgnoreList() {
      const data = await this.$store.dispatch("getIgnoreWinnerList");
      this.ignoreList = data;
    },

    setIgnoreWinner(item) {
      const find = this.findIgnore(item);
      if (!find) {
        // add to ignore if not in list
        const saved = {
          user_id: this.user_id,
          inn: item.winner_inn,
          name: item.winner_name.shortName,
          address: item.address,
        };
        this.$store.dispatch("setIgnoreWinner", saved).then(() => {
          this.getIgnoreList();
        });
        return;
      }

      this.removeIgnoreWinner(find.id);
    },
    async removeIgnoreWinner(id) {
      const data = await this.$store.dispatch("removeIgnoreWinner", {
        id,
        user_id: this.user_id,
      });
      data && this.getIgnoreList();
    },
    changeStyle(evt) {
      this.showFilter = evt;
      if (evt) {
        this.cardStyle = "height: calc(100vh - 345px); overflow: hidden";
        return;
      }
      this.cardStyle = "height: calc(100vh - 131px); overflow: hidden";
    },
    generateGetObject() {
      const getObj = {
        sortBy: this.sortBy && this.sortBy[0] ? this.sortBy[0] : null,
        sortDesc: this.sortDesc && this.sortDesc[0] ? this.sortDesc[0] : null,
        itemsPerPage: this.options.itemsPerPage,
        law: this.law,
        page: this.options.page,
        needGO: this.needGO,
        go_range: [parseFloat(this.go_range[0]), parseFloat(this.go_range[1])],
        winner_inn: this.winner_inn ? this.winner_inn : null,
        notificationNumber: this.notificationNumber
          ? this.notificationNumber
          : null,
      };

      if (this.radioDateSelected === "По сроку контракта") {
        getObj.contract_date_from = this.checkDateToNormal(this.date)[0]
          ? this.checkDateToNormal(this.date)[0]
          : null;
        getObj.contract_date_to = this.checkDateToNormal(this.date)[1]
          ? this.checkDateToNormal(this.date)[1]
          : null;
      }
      if (this.radioDateSelected === "По сроку обязательств") {
        getObj.delivery_date_from = this.checkDateToNormal(this.date)[0]
          ? this.checkDateToNormal(this.date)[0]
          : null;
        getObj.delivery_date_to = this.checkDateToNormal(this.date)[1]
          ? this.checkDateToNormal(this.date)[1]
          : null;
      }

      return getObj;
    },
    checkObj(obj, cb) {
      if (
        obj.contract_date_from === null ||
        obj.contract_date_to === null ||
        obj.delivery_date_from === null ||
        obj.delivery_date_to === null
      ) {
        Swal.fire({
          icon: "error",
          title: "Ошибка заполнения полей",
          html: "Срок контракта <br/> <strong>ИЛИ</strong> <br/>Срок обязательств <br/> <strong>должны быть заполнены!</strong>",
        });
        cb()
        return true
      }
    },
    async find() {
      this.loading = true;
      const getObj = this.generateGetObject();
      if (this.checkObj(getObj, () => (this.loading = false))) {
        return
      }
      try {
        await this.$store.dispatch("GET_REGISTER_BG", getObj);
      } finally {
        this.loading = false;
      }
    },
    async init() {
      await this.find(); // get data
    },
    async updateContact(inn) {
      await this.$store.dispatch("GET_FIRM_CONTACTS_UPDATE", inn);
    },
    checkDateToNormal(dateArr) {
      const arr = [];
      arr.push(+new Date(dateArr[0]));
      arr.push(+new Date(dateArr[1]));
      return arr.sort((a, b) => a - b);
    },
    // setContractDate() {
    //   this.contractDate = [];
    //   const nowDate = moment().format("YYYY-MM-DD");
    //   const date_to = moment(nowDate)
    //     .add(this.contractDays, "days")
    //     .format("YYYY-MM-DD");
    //   this.contractDate.push(nowDate);
    //   this.contractDate.push(date_to);
    //   // this.$refs.menuContract.save(this.contractDate);
    // },
    async saveAllToFile() {
      this.loadingFile = true;
      const getObj = this.generateGetObject();
      if (this.checkObj(getObj, () => (this.loadingFile = false))) {
        return
      }

      try {
        await this.$store.dispatch("GET_REGISTER_BG_FILE", getObj);
      } finally {
        this.loadingFile = false;
      }
    },
    async saveAllToFileFromRobot() {
      this.robotxlsLoading = true;
      const getObj = this.generateGetObject();
      if (this.checkObj(getObj, () => (this.robotxlsLoading = false))) {
        return
      }

      try {
        await this.$store.dispatch("GET_REGISTER_BG_FILE_TO_ROBOT", getObj);
      } finally {
        this.robotxlsLoading = false;
      }

    },
    colorize(item) {
      this.changeColor = true;
      this.selectRow = item;
    },
    async setColorRow() {
      const color = this.rowColor;
      const row = this.selectRow;
      const saveObj = {
        notificationNumber: row.notificationNumber,
        color,
        user_id: this.$store.getters.user_id,
      };
      row !== null &&
        this.$store.getters.user_id !== null &&
        (await this.$store.dispatch("PUT_ROW_COLOR", saveObj));
      this.selectRow = null;
      this.changeColor = false;
    },
    async getRowsColor() {
      await this.$store.dispatch("GET_ROWS_COLOR", this.$store.getters.user_id);
    },
    async removeColor() {
      const row = this.selectRow;
      const saveObj = {
        notificationNumber: row.notificationNumber,
        user_id: this.$store.getters.user_id,
      };
      row !== null &&
        this.$store.getters.user_id !== null &&
        (await this.$store.dispatch("DELETE_ROW_COLOR", saveObj));
      this.selectRow = null;
      this.changeColor = false;
    },
    chancelHeadersChange() {
      localStorage.setItem("_hs", JSON.stringify(headers));
      this.headers = headers;
      this.headersFilter = false;
    },
    saveHeaders() {
      localStorage.setItem("_hs", JSON.stringify(this.headers));
      this.headersFilter = false;
    },
    getHeaders() {
      const head = localStorage.getItem("_hs");
      if (head) {
        this.headers = JSON.parse(head);
      }
    },
    toDefault() {
      const date = moment().format("YYYY-MM-DD");
      const tomorow = moment().add(1, "day").format("YYYY-MM-DD");
      this.date = [date, tomorow];
      this.contractDate = ["", ""];
      this.winner_inn = null;
      this.go_range = [10, 1000000000000];
      this.notificationNumber = null;
    },
    async toCalc(item) {
      await this.$store.dispatch("setNewCalculation");
      await this.$store.dispatch("clearResults");
      await this.$store.dispatch("CLEAR_PROTOCOL_INFO");
      this.$store.commit("setProtocolInfoShowed", false);
      this.setCalcByRegisterBG(item);
    },
  },
  async mounted() {
    this.setTitle("Реестр ГО");
    this.getHeaders();
    // await this.init();
    await this.getRowsColor();
    await this.getIgnoreList();
  },
  computed: {
    protocolsRegisterBG() {
      return this.$store.getters.registerBG;
    },
    totalDesserts() {
      return this.$store.getters.registerBGTotal;
    },
    swatches() {
      return this.$store.getters.swatches;
    },
    showSwatches() {
      return this.swatches.length > 0 ? true : false;
    },
    filtredHeaders() {
      return this.headers.filter((item) => item.show);
    },
    user_id: {
      get() {
        return this.$store.getters.user_id;
      },
    },
  },
  watch: {
    // async contractDays() {
    //   this.setContractDate();
    // },
    async contractDate() {
      // this.setContractDate();
      if (this.contractDate.length == 2) {
        // this.$refs.menuContract.save(this.contractDate);§
      }
    },
    radioDateSelected() {
      const date = DeepCopy(this.date);
      this.date = date;
    },
    async options() {
      await this.find();
    },
    // async sortBy() {
    //   this.$store.commit("SET_REGISTER_BG", []);
    //   await this.find();
    // },
    // async sortDesc() {
    //   this.$store.commit("SET_REGISTER_BG", []);
    //   await this.find();
    // },
    async updateItemsPerPage() {
      this.$store.commit("SET_REGISTER_BG", []);
      await this.find();
    },
  },
};
</script>
<style lang="sass">
.register_bg_table
  // height: calc(100vh - 76px)
  .v-data-table__wrapper
    height: calc(100vh - 208px) !important
    overflow-x: auto
    overflow-y: auto
  &.show_filter
    .v-data-table__wrapper
      height: calc(100vh - 417px) !important
  .v-data-footer
    position: absolute !important
    bottom: 10px !important
    display: flex !important
    width: 100% !important
.flex
  display: flex
.colors_block
  display: flex
  flex-wrap: wrap
  column-gap: 10px
  row-gap: 10px
  span
    width: 45px
    height: 25px
    display: block
    cursor: pointer
.xls
  display: grid
  justify-content: center
  align-items: center
  justify-items: center
  row-gap: 10px
  padding: 10px
  width: 80px
  span
    padding: 0
    margin: 0
  &:hover
    background-color: rgba(black, 0.1)
</style>
